type Logo = {
    default: string;
    small: string;
};

type Palette = {
    primary?: string;
    secondary?: string;
    nav?: {
        bg: string;
        color: string;
    };
    menu?: {
        active: {
            bg: string;
            color: string;
        };
    };
};

const THEME = 'edito';

export const LOGO: Record<string, Logo> = {
    light: {
        default: `/img/natura-logo-color.png`,
        small: `/img/natura-logo-color-sm.png`
    },
    dark: {
        default: `/img/natura-logo-white.png`,
        small: `/img/natura-logo-white-sm.png`
    }
};

export const PALETTES: Record<string, Palette> = {
    default: {
        primary: 'var(--bs-orange)'
    },
    blue: {
        primary: '#01719f',
        secondary: '#0295d4'
    },
    graphite: {
        primary: '#2C363E',
        secondary: '#4b5a68'
    },
    darkred: {
        primary: '#990000',
        secondary: '#DD0000'
    },
    darkgreen: {
        primary: '#054700',
        secondary: '#217a00'
    },
    violet: {
        primary: '#670c45',
        secondary: '#993b89'
    }
};

export const BACKGROUNDS: Record<string, Palette> = {
    default: {
        nav: {
            bg: 'var(--ideo-accent-bg)',
            color: 'var(--bs-white)'
        }
    },
    white: {
        nav: {
            bg: '#FFFFFF',
            color: '#3D3D3D'
        }
    }
};
